var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1428 4.28516H2.57143C1.15127 4.28516 0 5.43642 0 6.85658V21.428C0 22.8481 1.15127 23.9994 2.57143 23.9994H17.1428C18.563 23.9994 19.7143 22.8481 19.7143 21.428V6.85658C19.7143 5.43642 18.563 4.28516 17.1428 4.28516ZM18 21.428C18 21.9014 17.6162 22.2852 17.1428 22.2852H2.57143C2.09802 22.2852 1.71427 21.9014 1.71427 21.428V6.85658C1.71427 6.38318 2.09802 5.99942 2.57143 5.99942H17.1428C17.6162 5.99942 18 6.38318 18 6.85658V21.428Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4286 0H6.00002C4.57985 0 3.42859 1.15127 3.42859 2.57143C3.42859 3.04483 3.81234 3.42859 4.28575 3.42859C4.75915 3.42859 5.14286 3.04483 5.14286 2.57143C5.14286 2.09802 5.52661 1.71427 6.00002 1.71427H21.4286C21.902 1.71427 22.2857 2.09802 22.2857 2.57143V18C22.2857 18.4734 21.902 18.8571 21.4286 18.8571C20.9552 18.8571 20.5714 19.2409 20.5714 19.7143C20.5714 20.1877 20.9552 20.5715 21.4286 20.5715C22.8487 20.5715 24 19.4202 24 18V2.57143C24 1.15127 22.8487 0 21.4286 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3ee7a1e4.svg";
export { ForwardRef as ReactComponent };